import script from "./GastoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GastoCard.vue?vue&type=script&setup=true&lang=js"

import "./GastoCard.vue?vue&type=style&index=0&id=5d9ec678&lang=css"

const __exports__ = script;

export default __exports__